import { ActionReducer, Action } from "@ngrx/store"
import { MatrixClassesStore } from "@store/matrix-classes"
import { ClassesManagerState } from "../states/classes-manager"
import { MatrixClass } from "@models/matrix-class"


export const matrixClassesReducer: ActionReducer<MatrixClassesStore> = (state: MatrixClassesStore = new MatrixClassesStore(), action: Action) => {

  switch(action.type) {
    case POPULATE_CLASSES:
      return new MatrixClassesStore(
        [...action.payload],
        state.editableClass,
        state.activeClass,
        [...state.teachers],
        ClassesManagerState.clone(state.classesManagerState),
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])
      
    case POPULATE_TEACHERS:
      return new MatrixClassesStore(
        [...state.matrixClasses],
        MatrixClass.clone(state.editableClass),
        MatrixClass.clone(state.activeClass),
        action.payload,
        ClassesManagerState.clone(state.classesManagerState),
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])

    case REPLACE_CLASS:
      const p = action.payload
      const matrixClasses = state.matrixClasses.map((c) => {
        if (c.id === p.id) { return p }; return c;
      })
      const active = state.activeClass.id === p.id ? p : state.activeClass
      const editable = state.editableClass.id === p.id ? p : state.editableClass

      return new MatrixClassesStore(
        matrixClasses,
        active,
        editable,
        [...state.teachers],
        state.classesManagerState,
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])

    case ADD_CLASS:
      return new MatrixClassesStore(
        [...state.matrixClasses, action.payload],
        MatrixClass.clone(state.editableClass),
        MatrixClass.clone(state.activeClass),
        [...state.teachers],
        ClassesManagerState.clone(state.classesManagerState),
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])

    case POPULATE_ACTIVE_CLASS: 
      return new MatrixClassesStore(
        [...state.matrixClasses],
        MatrixClass.clone(state.editableClass),
        action.payload,
        [...state.teachers],
        ClassesManagerState.clone(state.classesManagerState),
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])

    case POPULATE_EDITABLE_CLASS: 
      return new MatrixClassesStore(
        [...state.matrixClasses],
        action.payload,
        MatrixClass.clone(state.activeClass),
        [...state.teachers],
        ClassesManagerState.clone(state.classesManagerState),
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])

    case CM_STATE_SET_ACTIVE_CAMPUS:
      return new MatrixClassesStore(
        [...state.matrixClasses],
        MatrixClass.clone(state.editableClass),
        MatrixClass.clone(state.activeClass),
        [...state.teachers],
        ClassesManagerState.clone(Object.assign({}, state.classesManagerState, { activeCampus: action.payload })),
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])

    case CM_STATE_SET_ACTIVE_DAY:
      return new MatrixClassesStore(
        [...state.matrixClasses],
        MatrixClass.clone(state.editableClass),
        MatrixClass.clone(state.activeClass),
        [...state.teachers],
        ClassesManagerState.clone(Object.assign({}, state.classesManagerState, { activeDay: action.payload })),
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])

    case CM_STATE_SET_ACTIVE_TERM:
      return new MatrixClassesStore(
        [...state.matrixClasses],
        MatrixClass.clone(state.editableClass),
        MatrixClass.clone(state.activeClass),
        [...state.teachers],
        ClassesManagerState.clone(Object.assign({}, state.classesManagerState, { activeTerm: action.payload })),
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])

    case CM_STATE_SET_ACTIVE_HOLIDAY_WEEK:
      return new MatrixClassesStore(
        [...state.matrixClasses],
        MatrixClass.clone(state.editableClass),
        MatrixClass.clone(state.activeClass),
        [...state.teachers],
        ClassesManagerState.clone(Object.assign({}, state.classesManagerState, { activeHolidayWeek: action.payload })),
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])

    case POPULATE_CLASSSES_FOR_FROM_TERM:
      return new MatrixClassesStore(
        [...state.matrixClasses],
        state.editableClass,
        state.activeClass,
        [...state.teachers],
        state.classesManagerState,
        action.payload,
        [...state.classesRolloverTermTo],
        [...state.classRolloverResult])


    case POPULATE_CLASSSES_FOR_TO_TERM:
      return new MatrixClassesStore(
        [...state.matrixClasses],
        state.editableClass,
        state.activeClass,
        [...state.teachers],
        state.classesManagerState,
        [...state.classesRolloverTermFrom],
        action.payload,
        [...state.classRolloverResult])

    case POPULATE_CLASS_ROLLOVER_RESULT:
      return new MatrixClassesStore(
        [...state.matrixClasses],
        state.editableClass,
        state.activeClass,
        [...state.teachers],
        state.classesManagerState,
        [...state.classesRolloverTermFrom],
        [...state.classesRolloverTermTo],
        action.payload)

    default:
      return state
  }

}

export const FETCH_CLASSES = "FETCH_CLASSES"
export const FETCH_CLASSES_FAILURE = "FETCH_CLASSES_FAILURE"
export const FETCH_CLASS = "FETCH_CLASS"
export const FETCH_CLASS_FAILURE = "FETCH_CLASS_FAILURE"
export const FETCH_TEACHERS = "FETCH_TEACHERS"
export const FETCH_TEACHERS_FAILURE = "FETCH_TEACHERS_FAILURE"
export const POPULATE_CLASSES = "POPULATE_CLASSES"
export const POPULATE_TEACHERS = "POPULATE_TEACHERS"
export const POPULATE_ACTIVE_CLASS = "POPULATE_ACTIVE_CLASS"
export const POPULATE_EDITABLE_CLASS = "POPULATE_EDITABLE_CLASS"
export const CREATE_CLASS = "CREATE_CLASS"
export const CREATE_CLASS_FAILURE = "CREATE_CLASS_FAILURE"
export const ADD_CLASS = "ADD_CLASS"
export const UPDATE_CLASS = "UPDATE_CLASS"
export const UPDATE_CLASS_FAILURE = "UPDATE_CLASS_FAILURE"
export const REPLACE_CLASS = "REPLACE_CLASS"
export const CM_STATE_SET_ACTIVE_CAMPUS = "CM_STATE_SET_ACTIVE_CAMPUS"
export const CM_STATE_SET_ACTIVE_DAY = "CM_STATE_SET_ACTIVE_DAY"
export const CM_STATE_SET_ACTIVE_TERM = "CM_STATE_SET_ACTIVE_TERM"
export const CM_STATE_SET_ACTIVE_HOLIDAY_WEEK = "CM_STATE_SET_ACTIVE_HOLIDAY_WEEK"
export const FETCH_CLASSSES_FOR_TO_TERM = "FETCH_CLASSSES_FOR_TO_TERM"
export const POPULATE_CLASSSES_FOR_TO_TERM = "POPULATE_CLASSSES_FOR_TO_TERM"
export const FETCH_CLASSSES_FOR_FROM_TERM = "FETCH_CLASSSES_FOR_FROM_TERM"
export const POPULATE_CLASSSES_FOR_FROM_TERM = "POPULATE_CLASSSES_FOR_FROM_TERM"
export const CLASS_ROLLOVER = "CLASS_ROLLOVER"
export const POPULATE_CLASS_ROLLOVER_RESULT = "POPULATE_CLASS_ROLLOVER_RESULT"
export const CLASS_ROLLOVER_FAILURE = "CLASS_ROLLOVER_FAILURE"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/matrix-class.ts